import { List, useRecordContext } from "react-admin";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { PageTitle } from "../../misc/PageTitle";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { Row } from "../../misc/Row";
import { Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router";
import AddIcon from "@mui/icons-material/Add";
import { grants } from "../../backoffice.access_control";
import { AccessDenied } from "../../misc/AccessDenied";
import { EmptyState } from "../../misc/EmptyState";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { OtherEventCategoriesDataGrid } from "./OtherEventCategoriesDataGrid";

export function DrivingSchoolOtherEventCategories() {
  const drivingSchool = useRecordContext<DrivingSchool>();
  const navigate = useNavigate();
  if (!grants.has("OtherEvent:category:list")) {
    return <AccessDenied />;
  }
  if (!drivingSchool) {
    return (
      <>
        <PageTitle>Sonstige Arbeitszeiten</PageTitle>
        <LoadingIndicator />
      </>
    );
  }

  const empty = <EmptyState />;

  return (
    <div style={{ position: "relative" }}>
      <Row
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: "30px", minHeight: "32px", columnGap: 2, flexWrap: { xs: "wrap", sm: "nowrap" }, rowGap: 1 }}
      >
        <PageTitle documentTitle="Sonstige Arbeitszeiten">
          <h2 style={{ margin: 0, lineHeight: 0.83 }}>Sonstige Arbeitszeiten</h2>
        </PageTitle>
        {grants.has("OtherEvent:category:create") && (
          <>
            <IconButton
              aria-label="Sonstige Arbeitszeit hinzufügen"
              color="primary"
              onClick={() => navigate("/otherEventCategories/create")}
              size="small"
              sx={{ display: { xs: "inline-flex", sm: "none" } }}
            >
              <AddIcon />
            </IconButton>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => navigate("/otherEventCategories/create")}
              size="small"
              sx={{ display: { xs: "none", sm: "inline-flex" } }}
            >
              Hinzufügen
            </Button>
          </>
        )}
      </Row>
      <ResponsiveListSurface variant="compactStandalone" data-testid="DrivingSchoolOtherEventCategories">
        <List
          resource="otherEventCategories"
          title=" "
          actions={false}
          filter={{ drivingSchoolId: drivingSchool.id }}
          sort={/* initial sort order: */ { field: "name", order: "ASC" }}
          exporter={false}
          hasCreate={false}
          empty={empty}
        >
          <OtherEventCategoriesDataGrid empty={empty} />
        </List>
      </ResponsiveListSurface>
    </div>
  );
}
